import {useListView} from '../../core/ListViewProvider'
import {JudolListSearchComponent} from './JudolListSearchComponent'
import {JudolListToolbar} from './JudolListToolbar'

const JudolListHeader = () => {
  const {selected} = useListView()
  return (
    <>
      <div className='card-header border-0 pt-6 flex-column'>
        <div className="flex-xxl-grow-1 flex-grow-0">
          <JudolListSearchComponent />
        </div>
          <div className='card-toolbar flex-end'>
            <JudolListToolbar />
          </div>
        </div>
      </>
      )
      }

      export {JudolListHeader}
